import { creator_apis } from './creator_api';
import { wconcept_dashboard_apis } from './dashboard_apis';
import { user_apis } from './user_apis';

export const apis = {
	/////////////////wconcept
	...user_apis,
	...wconcept_dashboard_apis,
	...creator_apis,
};
